import { SxProps, Theme } from '@mui/material/styles';

export const labelControlSx: SxProps<Theme> = {};
